<template>
  <div class="col-12 connections">
    <div class="card">
      <div class="card-header">
        <h5 class="card-title mb-0">Связанные организации</h5>
      </div>

      <div class="d-flex navs">
        <ul class="nav nav-tabs">
          <li>
            <a
              class="active grey-button"
              id="lpec-tab"
              data-bs-toggle="tab"
              href="#tab-lpec"
              role="tab"
              aria-controls="tab-lpec"
              aria-selected="true"
              >Дочерние организации</a
            >
          </li>
          <li class="ms-4">
            <a
              class="grey-button"
              id="clp-tab"
              data-bs-toggle="tab"
              href="#tab-clp"
              role="tab"
              aria-controls="tab-clp"
              aria-selected="false"
              >Управляемые организации</a
            >
          </li>
          <li class="ms-4">
            <a
              class="grey-button"
              id="company-directors-tab"
              data-bs-toggle="tab"
              href="#tab-company-directors"
              role="tab"
              aria-controls="tab-company-directors"
              aria-selected="false"
              >По руководителю</a
            >
          </li>
          <li class="ms-4">
            <a
              class="grey-button"
              id="company-founders-tab"
              data-bs-toggle="tab"
              href="#tab-company-founders"
              role="tab"
              aria-controls="tab-company-founders"
              aria-selected="false"
              >По учредителю</a
            >
          </li>
        </ul>
      </div>
      <div class="card-body">
        <div class="tab-content" id="myTabContent">
          <!-- Первый таб -->
          <div
            class="tab-pane fade show active"
            id="tab-lpec"
            role="tabpanel"
            aria-labelledby="lpec-tab"
          >
            <ConnectionOrgs :connections="connectionsInfo.LPEC || []" />
          </div>

          <!-- Второй таб -->
          <div
            class="tab-pane fade"
            id="tab-clp"
            role="tabpanel"
            aria-labelledby="clp-tab"
          >
            <ConnectionOrgs :connections="connectionsInfo.CLP || []" />
          </div>

          <!-- Третий таб -->
          <div
            class="tab-pane fade"
            id="tab-company-directors"
            role="tabpanel"
            aria-labelledby="company-directors-tab"
          >
            <ConnectionDirectors
              :connectionDirectors="connectionsInfo.directors || []"
            />
          </div>

          <!-- Четвертый таб -->
          <div
            class="tab-pane fade"
            id="tab-company-founders"
            role="tabpanel"
            aria-labelledby="company-founders-tab"
          >
            <ConnectionDirectors
              :connectionDirectors="connectionsInfo.founder?.PP || []"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref } from "vue";
import ConnectionOrgs from "./ConnectionOrgs.vue";
import ConnectionDirectors from "./ConnectionDirectors.vue";

export default defineComponent({
  name: "Arbitration",
  components: {
    ConnectionOrgs,
    ConnectionDirectors,
  },
  props: {
    connectionsInfo: Object,
  },
  // setup(props) {
  // },
});
</script>
